//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
export default {
  props: {
    spec: {
      type: Object,
      required: true
    },
    type: {
      type: String,
      required: true
    },
    pattern: {
      type: String,
      required: true
    }
  },
  methods: {
    $internalizeValue: function $internalizeValue(val) {
      if (Utils.type.isString(val)) {
        return new Date(val).getTime() / 1000;
      }

      return null;
    },
    $externalizeValue: function $externalizeValue(val) {
      if (Utils.type.isNumber(val)) {
        var date = new Date(val * 1000);
        return Utils.format.local_iso8601(date);
      }

      return null;
    },
    $sanitizeValue: function $sanitizeValue(val) {
      if (val) {
        switch (this.type) {
          case "date":
            return val.slice(0, 10);

          case "month":
            return val.slice(0, 7);

          case "datetime-local":
            return val.slice(0, 16);

          default:
            return val;
        }
      }
    },
    classes: function classes() {
      return this.$classes().concat("g-text-field--hintless");
    }
  }
};